export const extractTextFromHTML = (htmlString) => {
  // console.log("inside functionssss",htmlString);
  
  if (!htmlString) return "";
  
  // Replace <br> and </p> with newlines to preserve formatting
  let textWithNewlines = htmlString.replace(/<br\s*[\/]?>/gi, "\n").replace(/<\/p>/gi, "\n");
  // Remove all remaining HTML tags
  textWithNewlines = textWithNewlines.replace(/<[^>]+>/g, "");
  
  const parser = new DOMParser();
  // const doc = parser.parseFromString(htmlString, "text/html");
  // return doc.body.textContent || "";

  const doc = parser.parseFromString(textWithNewlines, "text/html");
  return (doc.body.textContent || "").trim();
};
export const extractLetters = (text) => {
  text = text ?? "";
  return text?.length > 30 ? text.substring(0, 30) + "..." : text;
};


